import { render, staticRenderFns } from "./aChat.vue?vue&type=template&id=9095814a&scoped=true&"
import script from "./aChat.vue?vue&type=script&lang=js&"
export * from "./aChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9095814a",
  null
  
)

export default component.exports